import { Button, Container } from '../../components';
import styles from './logistic-ask.module.css';

export interface LogisticAskProps {
  title: string;
  text: string;
}

export default function LogisticAsk({ title, text }: LogisticAskProps) {
  return (
    <section className={styles.questions}>
      <Container>
        <div className={styles.questions__wrapper}>
          <div className={styles.questions__start}>
            <h6 className={styles.questions__title}>{title}</h6>
            <p className={styles.questions__text}>{text}</p>
          </div>
          <div className={styles.questions__end}>
            <Button tag="a" appearance="primary" href="/contact">
              Contact us
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
}
